let time = parseInt(document.querySelector('.tb-ind-slideshow').getAttribute('data-time'));
var bannerSwiper = new Swiper(".tb-ind-slideshow", {
  autoplay: {
    delay: time || 3000,
  },
  pagination: {
    el: ".swiper-pagination",
    clickable: true,
  },
  on: {
    init: function (swiper) {
      let index = this.activeIndex;
      $('.tb-ind-slideshow .tb-ind-slideshow-item').eq(index).find('.animated').addClass('fadeIn')
    },
    slideChangeTransitionEnd: function () {
      $('.tb-ind-slideshow .tb-ind-slideshow-item .animated').removeClass('fadeIn');
      $('.tb-ind-slideshow .tb-ind-slideshow-item').eq(this.activeIndex).find('.animated').addClass('fadeIn')
    },
  }
});

$('.tb-ind-slideshow').hover(function () {
    // over
    bannerSwiper.autoplay.stop();
  }, function () {
    // out
    bannerSwiper.autoplay.start();
  }
);

// let indAboutVideo = document.querySelector('#indAboutVideo')
// $('.tb-ind-about-cover').hover(function () {
//   $('#indAboutVideo').attr('controls', true)
// }, function () {
//   $('#indAboutVideo').attr('controls', false)
// });
// $('.tb-ind-about-cover .iconfont').click(function () {
//   $(this).fadeOut();
//   indAboutVideo.play();
// })

// indAboutVideo.addEventListener('play', function () { //开始
//   $('.tb-ind-about-cover .iconfont').fadeOut();
// });
// indAboutVideo.addEventListener('pause', function () { //暂停
//   $('.tb-ind-about-cover .iconfont').fadeIn();
// });
// indAboutVideo.addEventListener('ended', function () { //结束
//   $('.tb-ind-about-cover .iconfont').fadeIn();
// }, false);


var reviewSwiper = new Swiper('.tb-ind-review-container', {
  slidesPerView: 2.5,
  spaceBetween: 24,
  loop: true,
  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev',
  },
  on: {
    resize: function (swiper) {
      if (isMobile() || $(window).width() <= 768) {
        this.params.slidesPerView = 1.2;
        this.params.spaceBetween = 0;
      } else {
        this.params.slidesPerView = 2.5;
        this.params.spaceBetween = 24;
      }
      this.update();
    },
  },
});


var shareSwiper = new Swiper(".tb-ind-share-slide", {
  slidesPerView: 3,
  spaceBetween: 24,
  on: {
    resize: function (swiper) {
      if (isMobile() || $(window).width() <= 768) {
        this.params.slidesPerView = 1.2;
        this.params.spaceBetween = 12;
      } else {
        this.params.slidesPerView = 3;
        this.params.spaceBetween = 24;
      }
      this.update();
    },
  },
});


var blogSwiper = new Swiper(".tb-ind-blogs-slide", {
  spaceBetween:10,
  pagination: {
    el: ".swiper-pagination",
  },
  on: {
    init: function (swiper) {
      if (!isMobile() || $(window).width() > 768) {
        this.disable();
      }
    },
    resize: function (swiper) {
      if (isMobile() || $(window).width() <= 768) {
        this.update();
        this.enable();
      } else {
        this.disable();
      }
    },
  },
});

var userReviewSwiperEl = document.querySelector('.tb-ind-user-review-swiper');
if (userReviewSwiperEl) {
  var userReviewSwiper = new Swiper(".tb-ind-user-review-swiper", {
    slidesPerView: 3,
    spaceBetween: 24,
    watchOverflow: true,
    navigation: {
      nextEl: '.tb-ind-user-review-next',
      prevEl: '.tb-ind-user-review-prev',
    },
    pagination: {
      el: '.tb-ind-user-review-pagination',
      clickable: true,
    },
    on: {
      init: function () {
        if (isMobile() || $(window).width() <= 768) {
          this.params.slidesPerView = 1.14;
          this.params.spaceBetween = 16;
        } else {
          this.params.slidesPerView = 3;
          this.params.spaceBetween = 24;
        }
        this.update();
      },
      resize: function () {
        if (isMobile() || $(window).width() <= 768) {
          this.params.slidesPerView = 1.14;
          this.params.spaceBetween = 16;
        } else {
          this.params.slidesPerView = 3;
          this.params.spaceBetween = 24;
        }
        this.update();
      },
    },
  });
}
//console.log($('.index-review-div .swiper-slide-active img'));
//$('.index-review-div .swiper-slide-active img').width(768);
